<template>
  <zm-tiered-menu
    :data="meetingMenu"
    :z-index="1001"
    floating-content-class="frame-header-meeting-popover">
    <zm-button class="header-meeting-shortcuts-button" type="secondary" neutral :icon="VideoOn">
      {{ $t('meet') }}
    </zm-button>
  </zm-tiered-menu>
</template>

<script setup>
import { ZmTieredMenu, ZmButton } from '@zoom/zoom-ui-vue3'
import { VideoOn, PlusSquircle, CalendarNumber } from '@zoom/icons-vue'
import { axiosInstance } from '@/shared/api-helper'
import { onMounted, ref } from 'vue'
import { setUrlParam } from '@/shared/url-utils'
import { trackEvent } from '@/shared/event-tracker'
const iconMap = {
  host_meeting: VideoOn,
  join_meeting: PlusSquircle,
  schedule_meeting: CalendarNumber
}

const meetingMenu = ref([])

const menuCommand = (event) => {
  const menu = event.item
  if (!menu.url) {
    return
  }
  trackEvent({
    linkText: menu.id,
    linkUrl: menu.url,
    uiLocation: 'web portal navigation - top bar menu'
  })
  window.open(menu.url, '_blank')
}

const isMobileDevice = () => {
  return /Android|iPhone|iPad|iPod|Mobile/i.test(navigator.userAgent)
}

const jcs = `topbar-zw-${isMobileDevice() ? 'mBrw' : 'pcBrw'}`

const prependIcon = (menuList) => {
  const newMeetingItem = menuList.findIndex((item) => item.id === 'host_meeting')
  menuList.splice(newMeetingItem + 1, 0, { separator: true })
  return menuList.map((menu) => {
    if (menu.children) {
      menu.items = menu.children.map((menuItem) => {
        return {
          id: menuItem.id,
          label: menuItem.name,
          nameEn: menuItem.nameEn,
          url: setUrlParam(menuItem.url, 'jcs', jcs) || '',
          command: menuCommand
        }
      })
    }
    if (menu.separator) {
      return menu
    }
    return {
      id: menu.id,
      icon: iconMap[menu.id],
      label: menu.name,
      items: menu.items || [],
      nameEn: menu.nameEn,
      url: setUrlParam(menu.url, 'jcs', jcs) || '',
      command: menuCommand
    }
  })
}

const getMeetingShortcutMenu = async () => {
  const response = await axiosInstance.get('/waffle/available_items')
  const MeetingShortCut = response?.data?.result?.groupItems?.MeetingShortCut || []
  return prependIcon(MeetingShortCut)
}

onMounted(async () => {
  meetingMenu.value = await getMeetingShortcutMenu()
})
</script>

<style lang="scss">
.frame-header-meeting-popover {
  .fe-popups-tiered-menu__item-content {
    padding-left: 8px;
  }
  .fe-popups-tiered-menu__item-label {
    padding-right: 8px;
  }
}
</style>
